module.exports = __webpack_public_path__ + "img/56.cefb45b9.02df62a9.svg";